import type { FiltersConfig } from '@rocco/ui/filter-sort/types/filter-config-section';

/**
 * Search page product filters configuration
 *
 * This config matches the original dev branch PRODUCT_FILTERS_CONFIG to maintain
 * the original search page UX with the old design & the modal on the left.
 */
export const SEARCH_PRODUCT_FILTERS_CONFIG: FiltersConfig = {
    resultName: 'Product',
    barFilters: [
        {
            title: 'Suppliers',
            minContentWidth: 20,
            filters: [
                {
                    type: 'searchable',
                    aggregationProperty: 'aggProfessionals',
                    filterKey: 'professionals',
                    searchInputPlaceholder: 'Search by Name',
                    allowMultipleValues: true,
                    allowAlphabeticalGrouping: true,
                },
            ],
        },
        {
            title: 'Pricing',
            minContentWidth: 13.5,
            filters: [
                {
                    type: 'default',
                    filterKey: 'isInStock',
                    label: 'Buy online',
                },
                {
                    type: 'default',
                    filterKey: 'isOnSale',
                    label: 'On sale (Discount)',
                },
                {
                    type: 'price',
                    filterKey: 'priceRange',
                    label: 'Price Range',
                },
            ],
        },
    ],
    modalFilters: [
        {
            title: 'Pricing',
            collapsable: true,
            collapsedByDefault: false,
            filters: [
                {
                    type: 'default',
                    filterKey: 'isOnSale',
                    label: 'On sale (Discount)',
                },
                {
                    type: 'price',
                    filterKey: 'priceRange',
                    label: 'Price range',
                },
            ],
        },
        {
            title: 'Availability',
            collapsable: true,
            collapsedByDefault: true,
            filters: [
                {
                    type: 'default',
                    filterKey: 'isInStock',
                    label: 'In stock',
                },
                {
                    type: 'default',
                    filterKey: 'isDeliveryAvailable',
                    label: 'Delivery available',
                },
                {
                    type: 'default',
                    filterKey: 'isSampleAvailable',
                    label: 'Samples available',
                },
            ],
        },
        {
            title: 'Downloads',
            collapsable: true,
            collapsedByDefault: true,
            filters: [
                {
                    type: 'default',
                    filterKey: 'downloads',
                },
            ],
        },
        {
            title: 'Colour',
            collapsable: true,
            collapsedByDefault: true,
            filters: [
                {
                    type: 'color',
                    filterKey: 'colors',
                },
            ],
        },
        {
            title: 'Material',
            collapsable: true,
            collapsedByDefault: true,
            filters: [
                {
                    type: 'searchable',
                    aggregationProperty: 'aggProductMaterials',
                    filterKey: 'materials',
                    searchInputPlaceholder: 'Search by Name',
                    allowMultipleValues: true,
                    allowAlphabeticalGrouping: true,
                    columns: 1,
                },
            ],
        },
        {
            title: 'Size',
            collapsable: true,
            collapsedByDefault: true,
            columns: 1,
            filters: [
                {
                    type: 'simpleRange',
                    filterKey: 'lengthRange',
                    label: 'Length',
                    minPlaceholder: 'Min mm',
                    maxPlaceholder: 'Max mm',
                },
                {
                    type: 'simpleRange',
                    filterKey: 'widthRange',
                    label: 'Width',
                    minPlaceholder: 'Min mm',
                    maxPlaceholder: 'Max mm',
                },
                {
                    type: 'simpleRange',
                    filterKey: 'heightRange',
                    label: 'Height',
                    minPlaceholder: 'Min mm',
                    maxPlaceholder: 'Max mm',
                },
                {
                    type: 'simpleRange',
                    filterKey: 'diameterRange',
                    label: 'Diameter',
                    minPlaceholder: 'Min mm',
                    maxPlaceholder: 'Max mm',
                },
                {
                    type: 'simpleRange',
                    filterKey: 'weightRange',
                    label: 'Weight',
                    minPlaceholder: 'Min g',
                    maxPlaceholder: 'Max g',
                },
            ],
        },
        {
            title: 'Brand',
            collapsable: true,
            collapsedByDefault: true,
            filters: [
                {
                    type: 'searchable',
                    aggregationProperty: 'aggBrands',
                    filterKey: 'brands',
                    searchInputPlaceholder: 'Search by Brand',
                    allowMultipleValues: true,
                    allowAlphabeticalGrouping: true,
                    columns: 1,
                },
            ],
        },
        {
            title: 'Designer',
            collapsable: true,
            collapsedByDefault: true,
            filters: [
                {
                    type: 'searchable',
                    aggregationProperty: 'aggDesigners',
                    filterKey: 'designers',
                    searchInputPlaceholder: 'Search by Name',
                    allowMultipleValues: true,
                    allowAlphabeticalGrouping: true,
                    columns: 1,
                },
            ],
        },
        {
            title: 'Suppliers',
            collapsable: true,
            collapsedByDefault: true,
            filters: [
                {
                    type: 'searchable',
                    aggregationProperty: 'aggProfessionals',
                    filterKey: 'professionals',
                    searchInputPlaceholder: 'Search by Name',
                    allowMultipleValues: true,
                    allowAlphabeticalGrouping: true,
                    columns: 1,
                },
            ],
        },
        {
            title: 'Staff admin filters',
            collapsable: true,
            collapsedByDefault: true,
            adminOnly: true,
            filters: [
                {
                    type: 'default',
                    filterKey: 'invalidLink',
                    label: 'Invalid Link',
                },
                {
                    type: 'default',
                    filterKey: 'noCategory',
                    label: 'Uncategorised',
                },
                {
                    type: 'default',
                    filterKey: 'disabled',
                    label: 'Disabled',
                },
                {
                    type: 'default',
                    filterKey: 'profileOnly',
                    label: 'Profile Only',
                },
            ],
        },
    ],
};
